import logo from "@/assets/Images";
import { PowerIcon } from "@heroicons/react/24/outline";
import { ButtonBase, Image } from "@repo/ui/index.tsx";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { UseQueryResult } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { DateTime } from "luxon";
interface ILoggedInUserInfoProps {
  logoutModalHandler: () => void;
  authUserService: UseQueryResult<any, unknown>;
}

function LoggedInUserInfo({
  authUserService,
  logoutModalHandler,
}: ILoggedInUserInfoProps) {
  // Convert the last login date to a human-readable format
  const lastLoginData = DateTime.fromJSDate(
    new Date(authUserService?.data?.data?.last_login_at)
  ).toFormat("dd LLL yyyy, h:mm a");
  return (
    <motion.div
      initial={false}
      transition={{
        duration: 0.2,
        ease: [0.42, 0, 0.58, 1],
      }}
      className={`flex  flex-col gap-1 rounded-lg bg-white w-full p-2 shadow-lg shadow-primary/10 border border-extraLightGray  overflow-hidden h-20 `}
    >
      <section
        className={`flex items-center justify-between border-b border-extraLightGray/50 pb-1   `}
      >
        <div className="flex items-center gap-3">
          <section className="relative ">
            <Image
              src={
                authUserService?.data?.data?.avatar?.original_url ||
                logo.UserProfile
              }
              className={` ${"h-10   border-b border-extraLightGray"}    object-contain rounded-full`}
            />
          </section>

          <section className="leading-4 font-semibold whitespace-nowrap overflow-hidden">
            <p className="text-sm">
              {stringUtility.addEllipsisAtEnd(
                authUserService?.data?.data?.name,
                15
              )}
            </p>
            <p className="text-xs text-body">
              {stringUtility.addEllipsisAtEnd(
                authUserService?.data?.data?.roles?.[0]?.name,
                15
              )}
            </p>
          </section>
        </div>

        <ButtonBase
          onClick={logoutModalHandler}
          buttonType="tertiary"
          icon={<PowerIcon className="w-4 h-4" />}
          className="h-8 w-8 text-error bg-extraLightGray rounded-full p-1"
        />
      </section>

      <p className="text-xs font-semibold">
        <span className="text-darkGray">Last login: </span>
        <span className="text-heading">{lastLoginData}</span>
      </p>
    </motion.div>
  );
}

export default LoggedInUserInfo;
